import React from 'react';
import styles from './form-seperator.module.scss';
export const FormSeperator = () => {
    return React.createElement("div", { className: styles.seperator });
};
//# sourceMappingURL=form-seperator.js.map